// Currency display — prices are stored in EUR (base currency for Stripe).
// English users see INR (Indian home market), European-language users see EUR.
// We ALSO display the alternate currency in muted text next to the primary,
// so shoppers see ₹ and € side-by-side.
export const CURRENCIES = {
    en: { symbol: "₹", code: "INR", rate: 90, locale: "en-IN", digits: 0 },
    de: { symbol: "€", code: "EUR", rate: 1, locale: "de-DE", digits: 2 },
    fr: { symbol: "€", code: "EUR", rate: 1, locale: "fr-FR", digits: 2 },
    es: { symbol: "€", code: "EUR", rate: 1, locale: "es-ES", digits: 2 },
    it: { symbol: "€", code: "EUR", rate: 1, locale: "it-IT", digits: 2 },
};

// Base secondary currency shown alongside the primary — EUR for INR users,
// INR for everyone else.
const SECONDARY = {
    en: { symbol: "€", code: "EUR", rate: 1, locale: "en-IE", digits: 2 },
    de: { symbol: "₹", code: "INR", rate: 90, locale: "en-IN", digits: 0 },
    fr: { symbol: "₹", code: "INR", rate: 90, locale: "en-IN", digits: 0 },
    es: { symbol: "₹", code: "INR", rate: 90, locale: "en-IN", digits: 0 },
    it: { symbol: "₹", code: "INR", rate: 90, locale: "en-IN", digits: 0 },
};

export function currencyFor(lang) {
    return CURRENCIES[lang] || CURRENCIES.en;
}

function _fmt(cfg, eurAmount) {
    const value = Number(eurAmount || 0) * cfg.rate;
    try {
        return new Intl.NumberFormat(cfg.locale, {
            style: "currency",
            currency: cfg.code,
            minimumFractionDigits: cfg.digits,
            maximumFractionDigits: cfg.digits,
        }).format(value);
    } catch {
        return `${cfg.symbol}${value.toFixed(cfg.digits)}`;
    }
}

export function formatPrice(eurAmount, lang) {
    return _fmt(currencyFor(lang), eurAmount);
}

// Dual-currency string: e.g. "₹8,010 · €89"
export function formatDual(eurAmount, lang) {
    const primary = _fmt(currencyFor(lang), eurAmount);
    const secondaryCfg = SECONDARY[lang] || SECONDARY.en;
    const secondary = _fmt(secondaryCfg, eurAmount);
    return { primary, secondary, hasSecondary: true };
}
